import {computed} from "vue";
import {FieldType} from "@/components/business/crud/interface/FieldType";
import {AddFieldParam, WidgetContainer, WidgetItem} from "@/components/business/crud/widgets/WidgetContainer";
import {WidgetType} from "@/components/business/crud/interface/WidgetType";

export interface FormContainerGroup {
    title: string;
    inline: WidgetItem<WidgetType>[];
    block: WidgetItem<WidgetType>[];
}


export class FormWidgetContainer extends WidgetContainer<void, FieldType> {

    constructor() {
        super('edit', 'form');
    }

    use() {
        return {
            toggle: this.toggle.bind(this),
            groups: this.groups,
            canToggle: this.canToggle,
            status: this.status,
        }
    }

    addField(id: string, title: string, widget: FieldType, param?: AddFieldParam) {
        super.doAddField(id, title, widget, undefined, param);
    }

    public groups = computed(() => {
        const groups: FormContainerGroup[] = [];
        Object.values(this.groupMap.value).map(group => {
            const formGroup: FormContainerGroup = {
                title: group.title,
                inline: [],
                block: [],
            }
            group.items.map(item => {
                if (item.size === "large") {
                    formGroup.block.push(item);
                } else {
                    formGroup.inline.push(item);
                }
            })
            groups.push(formGroup)
        })
        // 防止出现只有1列的情况
        for (const group of groups) {
            const sizeMap = {
                small: [] as WidgetItem<WidgetType>[],
                normal: [] as WidgetItem<WidgetType>[],
                large: [] as WidgetItem<WidgetType>[],
            };
            for (const item of group.inline) {
                sizeMap[item.size].push(item);
            }
            if (sizeMap.small.length % 2 !== 0) {
                sizeMap.small[sizeMap.small.length - 1].size = "normal";
            }
            group.inline = [...sizeMap.small, ...sizeMap.normal];
        }
        return groups;
    })
}




